// Central place for business contact info — easy to update later.
export const BUSINESS = {
  name: "Perficient Building Services Ltd",
  shortName: "Perficient",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_services-perficient/artifacts/5v8y5riy_df910ff7-33bd-49ea-9409-bd3f361a02b1.jpeg",
  tagline:
    "Electrical, Plumbing, Gas, Air Conditioning and Property Maintenance Services for Homes and Businesses.",
  email: "admin@pftltd.co.uk",
  emailHref: "mailto:admin@pftltd.co.uk",
  area: "London & Surrounding Areas",
  hours: "Mon – Sat · 8:00 – 18:00 · Email enquiries answered same day",
};
